import { inject } from '@angular/core';
import { ActivatedRouteSnapshot, CanActivateFn, Router, UrlTree } from '@angular/router';
import { Store } from '@ngxs/store';
import { EnedisState, SetCurrentAccessRightId } from '../enedis.state';

export const enedisAccessRightGuard: CanActivateFn = (
    next: ActivatedRouteSnapshot,
): boolean | UrlTree => {
    const router = inject(Router);
    const store = inject(Store);
    let id = next.params['accessRightId'];

    if (id) {
        const enedisAccessRights = store.selectSnapshot(EnedisState.enedisAccessRights);
        if (!enedisAccessRights?.find((ear) => ear.id === id)) {
            store.dispatch([new SetCurrentAccessRightId({ id })]);
        }
        store.dispatch([new SetCurrentAccessRightId({ id })]);
        return true;
    }

    return router.parseUrl('/main/enedis');
};
